export const APPOINTMENT_SERVICE_REQUEST = 'APPOINTMENT_SERVICE_REQUEST';
export const APPOINTMENT_SERVICE_RECEIVE = 'APPOINTMENT_SERVICE_RECEIVE';
export const APPOINTMENT_SERVICE_FAILURE = 'APPOINTMENT_SERVICE_FAILURE';



// WEBPACK FOOTER //
// frontend/src/modules/mobile/constants/appointment.js